import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Spinner } from "react-bootstrap";
import {
  cnfPwdValidation,
  passLimitValidation,
  passCharValidation,
  SessionKeys,
  isConatainsSymbol,
} from "../utils/AppUtils";
import FooterNew from "../components/FooterNew";
import HeaderLogoSection from "../components/HeaderLogoSection";
import {
  setupPassword,
  setupPasswordBroker,
  setupPasswordBrokerClear,
  setupPasswordClear,
} from "../redux/auth/actions";
import _ from "lodash";
import Loader from "../components/Loader/Loader";
import MESSAGE from "../utils/messages";
import { useTranslation } from "react-i18next";
import { getActiveLanguage } from "../redux/home/actions";

const SetupPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const search = window.location.search;
  const params = new URLSearchParams(search);

  const { t, i18n } = useTranslation();

  const setupPasswordInfo = useSelector((state) => state.auth.setupPassword);
  const setupPasswordBrokerInfo = useSelector(
    (state) => state.auth.setupPasswordBroker,
  );
  const authBroker = useSelector((state) => state.auth.authBroker);
  const [password, setPassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");
  const [htmlFormError, setFormError] = useState("");
  const [htmlFormSuccess, setFormSuccess] = useState("");
  const [key, setKey] = useState(params.get("key"));
  const [emailId, setEmailId] = useState(params.get("email"));
  const [actionType, setActionType] = useState(params.get("action"));
  const [language, setLanguage] = useState("1");
  const [isUserAlreadyLogin, setIsUserAlreadyLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [infoModal, setInfoModal] = useState(false);
  const [showInfoModalMsg, setShowInfoModalMsg] = useState(
    MESSAGE.ACTIVE_IN_OTHER_TAB,
  );
  const [showSpinner, setShowSpinner] = useState(false);

  const [isPassLength, setIsPassLength] = useState(false);
  const [isSymbol, setIsSymbol] = useState(false);
  const [matchPassword, setMatchPassword] = useState(false);

  useEffect(() => {
    if (password && cnfPassword) {
      if (password === cnfPassword) {
        setMatchPassword(true);
      } else {
        setMatchPassword(false);
      }
    } else {
      setMatchPassword(false);
    }
  }, [password, cnfPassword]);

  useEffect(() => {
    if (language) {
      i18n.changeLanguage(language == "1" ? "en" : "fr");
      dispatch(getActiveLanguage(Number(language)));
    }
  }, [language]);

  useEffect(() => {
    if (document.getElementById("id_page_404") !== null) {
      document.getElementById("id_page_404").style.display = "none";
    }
  }, []);

  useEffect(() => {
    if (
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== null &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== "" &&
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER) !== undefined
    ) {
      if (authBroker.status === "success") {
        // console.log("inside authBroker setisUserAlready login", authBroker);
        setInfoModal(true);
        setIsUserAlreadyLogin(true);
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, [authBroker]);

  useEffect(() => {
    // console.log(setupPasswordInfo)
    if (!_.isEmpty(setupPasswordInfo)) {
      if (setupPasswordInfo.status === "success") {
        // console.log('Redirect to dashboard', emailId)
        // localStorage.removeItem(SessionKeys.API_TOKEN);
        localStorage.removeItem(SessionKeys.API_TOKEN_BROKER);
        navigate(`/login`, { state: { canLogin: true } });
      } else {
        // setFormError(setupPasswordInfo.error.message)
        navigate("/activation-expiry?email=" + emailId);
      }
      setShowSpinner(false);
      dispatch(setupPasswordClear());
    }
  }, [setupPasswordInfo]);

  useEffect(() => {
    // console.log('password', setupPasswordBrokerInfo)
    if (!_.isEmpty(setupPasswordBrokerInfo)) {
      // if (setupPasswordBrokerInfo.status === 'success') {
      //     console.log('Redirect to dashboard', emailId)
      //     navigate(`/`, {canLogin: true})
      // } else {
      //     // setFormError(setupPasswordInfo.error.message)
      //     navigate('/activation-expiry?email=' + emailId)
      // }
      // localStorage.removeItem(SessionKeys.API_TOKEN);
      if (setupPasswordBrokerInfo.status === "success") {
        // console.log('Redirect to dashboard', emailId)
        // localStorage.removeItem(SessionKeys.API_TOKEN);
        // localStorage.removeItem(SessionKeys.API_TOKEN_BROKER);
        navigate(`/login`, { state: { canLogin: true } });
      } else {
        // setFormError(setupPasswordInfo.error.message)
        navigate("/activation-expiry?email=" + emailId);
      }
      localStorage.removeItem(SessionKeys.API_TOKEN_BROKER);
      dispatch(setupPasswordBrokerClear());
    }
  }, [setupPasswordBrokerInfo]);

  const setupPwd = () => {
    if (!isUserAlreadyLogin) {
      setShowSpinner(true);
      // if (!passLimitValidation(password)) {
      //   setFormError("Please enter at least 6 characters.");
      //   setShowSpinner(false);
      // } else if (!passLimitValidation(cnfPassword)) {
      //   setFormError("Please enter at least 6 characters.");
      //   setShowSpinner(false);
      // } else if (!passCharValidation(password)) {
      //   setFormError(
      //     <>
      //       <ul className="setup-password-error">
      //         <li>Password must contain at least one uppercase letter</li>
      //         <li>Password must contain at least one lowercase letter</li>
      //         <li>Password must contain at least one number</li>
      //         <li>
      //           Password must contain at least one special character like
      //           !@#$%^&*
      //         </li>
      //       </ul>
      //     </>
      //   );
      //   setShowSpinner(false);
      // } else if (!passCharValidation(cnfPassword)) {
      //   setFormError(
      //     <>
      //       <ul className="setup-password-error">
      //         <li>Password must contain at least one uppercase letter</li>
      //         <li>Password must contain at least one lowercase letter</li>
      //         <li>Password must contain at least one number</li>
      //         <li>
      //           Password must contain at least one special character like
      //           !@#$%^&*
      //         </li>
      //       </ul>
      //     </>
      //   );
      //   setShowSpinner(false);
      // } else

      if (cnfPwdValidation(password, cnfPassword)) {
        const params = {
          "newpwd-btn": "NEW PASSWORD",
          action: "updatepassword",
          email: emailId,
          key: key,
          password: password,
        };
        // console.log(params)
        // dispatch(setupPassword(params))
        dispatch(
          setupPasswordBroker({
            password,
            token: key,
            // email: emailId,
            module: "realtor_update_password",
          }),
        );
      } else {
        setFormError(
          "Passwords do not match. Please enter the same password in both fields.",
        );
        setShowSpinner(false);
      }
    }
  };

  const renderAlertCard = () => {
    return (
      <div
        className={`cal-alert alert-card d-flex justify-content-center ${
          infoModal ? "" : "d-none"
        }`}
      >
        <div className="shop-cart">
          <div className="shop-info justify-content-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
            >
              <g
                id="Group_5699"
                data-name="Group 5699"
                transform="translate(0.498 0.498)"
              >
                <circle
                  id="Ellipse_222"
                  data-name="Ellipse 222"
                  cx="9"
                  cy="9"
                  r="9"
                  transform="translate(-0.498 -0.498)"
                  fill="#A9C23C"
                />
                <path
                  id="Icon_material-done"
                  data-name="Icon material-done"
                  d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z"
                  transform="translate(-3.013 -6.071)"
                  fill="#fff"
                  stroke="#fff"
                  strokeWidth="2"
                />
              </g>
            </svg>
            <p className="m-0">{showInfoModalMsg}</p>
          </div>
          <div className="view-cart-icon">
            <i
              className="fa fa-times cursor-pointer"
              aria-hidden="true"
              onClick={() => {
                setInfoModal(false);
              }}
            ></i>
          </div>
        </div>
      </div>
    );
  };

  const myFunction1 = () => {
    var x = document.getElementById("newPassInput");
    var y = document.getElementById("eyeImg1");
    if (x.type === "password") {
      x.type = "text";
      y.src = "/images/finwell-img/view.png";
    } else {
      x.type = "password";
      y.src = "/images/finwell-img/private.png";
    }
  };

  const myFunction2 = () => {
    var x = document.getElementById("newConfirmPassInput");
    var y = document.getElementById("eyeImg2");
    if (x.type === "password") {
      x.type = "text";
      y.src = "/images/finwell-img/view.png";
    } else {
      x.type = "password";
      y.src = "/images/finwell-img/private.png";
    }
  };

  return (
    <>
      <div className="login-ary setup-password">
        <section className="login-sec ">
          <div className="login-container ">
            {/* <div className="bannerlog-image d-block d-md-none image-login">
              <img className="img-fluid" src="/images/finwell-img/banner.png" />
            </div> */}
            <div className="container-fluid">
              <div className="row bglogin">
                <div className="col-xl-7 col-lg-6 col-sm-12 col-12 image-login">
                  <img
                    className="img-fluid"
                    src="/images/finwell-img/banner.png"
                    alt="home-scene-login"
                  />
                </div>
                <div className="col-xl-5 col-lg-6 col-sm-12 col-12 ttxt">
                  <div className="login-text">
                    <div className="text-center lgo-box">
                      <svg
                        width="60"
                        height="60"
                        viewBox="0 0 60 60"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_d_3502_8576)">
                          <rect
                            x="2"
                            y="1"
                            width="56"
                            height="56"
                            rx="12"
                            fill="white"
                          />
                          <rect
                            x="2.5"
                            y="1.5"
                            width="55"
                            height="55"
                            rx="11.5"
                            stroke="#EAECF0"
                          />
                          <path
                            d="M35.8327 26.6667V24.3333C35.8327 21.1117 33.221 18.5 29.9993 18.5C26.7777 18.5 24.166 21.1117 24.166 24.3333V26.6667M29.9993 31.9167V34.25M26.266 39.5H33.7327C35.6929 39.5 36.673 39.5 37.4217 39.1185C38.0802 38.783 38.6156 38.2475 38.9512 37.589C39.3327 36.8403 39.3327 35.8602 39.3327 33.9V32.2667C39.3327 30.3065 39.3327 29.3264 38.9512 28.5777C38.6156 27.9191 38.0802 27.3837 37.4217 27.0481C36.673 26.6667 35.6929 26.6667 33.7327 26.6667H26.266C24.3058 26.6667 23.3257 26.6667 22.577 27.0481C21.9185 27.3837 21.383 27.9191 21.0475 28.5777C20.666 29.3264 20.666 30.3065 20.666 32.2667V33.9C20.666 35.8602 20.666 36.8403 21.0475 37.589C21.383 38.2475 21.9185 38.783 22.577 39.1185C23.3257 39.5 24.3058 39.5 26.266 39.5Z"
                            stroke="#344054"
                            strokeWidth="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_3502_8576"
                            x="0"
                            y="0"
                            width="60"
                            height="60"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dy="1" />
                            <feGaussianBlur stdDeviation="1" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_3502_8576"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_3502_8576"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                    </div>
                    <h2 className="text-center logtitle">
                      {t("Setup your Password")}
                    </h2>
                    {/* <p className="ms-2-message text-center">
                      We sent a password reset link to <strong>allen@century21.com</strong>
                    </p> */}

                    {isUserAlreadyLogin ? (
                      <div className="col-md-12 messgebox">
                        <div className="alert-card d-flex justify-content-center topsecalert ">
                          <div className="shop-cart order-details alert-notify-sucess">
                            <div className="shop-info justify-content-center">
                              {showInfoModalMsg}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <p className="user mb-2">{t("Email Address")}</p>
                    <p className="john-id">
                      <strong>{emailId}</strong>
                    </p>
                    <form
                      onSubmit={(event) => {
                        event.preventDefault();
                        if (!isPassLength || !isSymbol || !matchPassword) {
                          return;
                        }
                        setupPwd();
                      }}
                      className={`${isUserAlreadyLogin ? "blur-section" : ""}`}
                    >
                      <div className="input-text ">
                        <label htmlFor="password" className="input__label">
                          {t("enter_new_password")}
                        </label>
                        <div className="position-relative">
                          <input
                            type="password"
                            id="newPassInput"
                            className="input__field"
                            placeholder={t("Enter Password")}
                            aria-label="password"
                            aria-describedby="basic-addon1"
                            disabled={isUserAlreadyLogin}
                            onChange={(e) => {
                              console.log("onChange: ", e.target.value);
                              if (
                                !(
                                  _.isEmpty(e.target.value) ||
                                  e.target.value?.length < 8
                                )
                              )
                                setIsPassLength(true);
                              else setIsPassLength(false);

                              if (
                                !_.isEmpty(e.target.value) &&
                                isConatainsSymbol(e.target.value)
                              )
                                setIsSymbol(true);
                              else setIsSymbol(false);

                              setPassword(e.target.value);
                            }}
                          />
                          <div
                            className="show-pass"
                            onClick={() => {
                              myFunction1();
                            }}
                          >
                            <img
                              id="eyeImg1"
                              src="/images/finwell-img/private.png"
                              alt="view"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="input-text  ">
                        <label
                          htmlFor="confirm_password"
                          className="input__label"
                        >
                          {t("confirm_new_password")}
                        </label>
                        <div className="position-relative">
                          <input
                            type="password"
                            id="newConfirmPassInput"
                            className="input__field"
                            placeholder={t("Confirm Password")}
                            aria-label="password"
                            aria-describedby="basic-addon1"
                            disabled={isUserAlreadyLogin}
                            onChange={(e) => setCnfPassword(e.target.value)}
                          />
                          <div
                            className="show-pass"
                            onClick={() => {
                              myFunction2();
                            }}
                          >
                            <img
                              id="eyeImg2"
                              src="/images/finwell-img/private.png"
                              alt="view"
                            />
                          </div>
                        </div>
                      </div>
                      <div className={"validation-pass"}>
                        <div
                          className={`valid-text ${
                            isPassLength ? "active" : ""
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <rect
                              width="20"
                              height="20"
                              rx="10"
                              fill={"#D1D1D1"}
                            />
                            <path
                              d="M6.25 10L8.75 12.5L13.75 7.5"
                              stroke="white"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {t("must_be_at_least_8_characters")}
                        </div>
                        <div
                          className={`valid-text ${isSymbol ? "active" : ""}`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <rect
                              width="20"
                              height="20"
                              rx="10"
                              fill={"#D1D1D1"}
                            />
                            <path
                              d="M6.25 10L8.75 12.5L13.75 7.5"
                              stroke="white"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {t("must_contain_one_special_character")}
                        </div>
                        <div
                          className={`valid-text ${
                            matchPassword ? "active" : ""
                          }`}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <rect
                              width="20"
                              height="20"
                              rx="10"
                              fill={"#D1D1D1"}
                            />
                            <path
                              d="M6.25 10L8.75 12.5L13.75 7.5"
                              stroke="white"
                              strokeWidth="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {t("must_match_confirm_new_password")}
                        </div>
                      </div>
                      <div className="save_button">
                        {showSpinner ? (
                          <button className="default-btn signinBtn session-btn mt-4 w-100 ">
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="default-btn signinBtn session-btn mt-4 w-100  "
                            disabled={isUserAlreadyLogin}
                          >
                            {t("Set Password")}
                          </button>
                        )}
                        <div className="mb-2 login-msg">
                          {htmlFormError && <div>{htmlFormError}</div>}
                          {htmlFormSuccess && <div>{htmlFormSuccess}</div>}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* <div className="page-wrapper-rsp">
            
            <HeaderLogoSection />
            <div className="header-border"></div>
            <Loader start={isLoading} />
            <section className="setup-password">
                <div className="container">
                    {renderAlertCard()}
                    <div className="row">
                        {isUserAlreadyLogin ?
                        <div className="col-md-12 messgebox">
                            <div className="alert-card d-flex justify-content-center  topsecalert">
                                 <div className="shop-cart order-details alert-notify-sucess">
                                    <div className="shop-info justify-content-center">
                                        {showInfoModalMsg} 
                                    </div>
                                </div>
                           </div> 
                        </div>
                        : ''
                        }
                        <div className={`col-8 col-sm-7 col-md-5 col-xl-4 col-lg-4 right-space ${isUserAlreadyLogin ? "blur-section" : ""}`}>
                            
                            <div className="heading ">
                                <h3>Setup your Password</h3>
                            </div>
                            <p className="user pt-2">Email Address</p>
                            <p className="john-id"><strong>{emailId}</strong></p>
                            <form onSubmit={(event) => {
                                event.preventDefault();
                                setupPwd()
                            }}>
                                <div className="input-text position-relative">
                                    <label htmlFor="password" className="input__label">Enter Password</label>
                                    <input type="password" className="input__field"
                                        placeholder="Enter Password"
                                        aria-label="password" aria-describedby="basic-addon1"
                                        disabled={isUserAlreadyLogin}
                                        onChange={(e) => setPassword(e.target.value)} />
                                </div>
                                <div className="input-text  position-relative">
                                    <label htmlFor="confirm_password" className="input__label">Confirm Password</label>
                                    <input type="password" className="input__field" placeholder="Confirm Password"
                                        aria-label="password" aria-describedby="basic-addon1"
                                        disabled={isUserAlreadyLogin}
                                        onChange={(e) => setCnfPassword(e.target.value)} />
                                </div>


                                <div className="save_button">
                                    {
                                        showSpinner ?
                                        <Button
                                        className="btn btn-primary setup-button" >
                                        <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        />
                                        </Button>
                                        :
                                        <Button 
                                            type="submit"
                                            className="btn btn-primary setup-button"
                                            disabled={isUserAlreadyLogin}
                                        >
                                        Set Password</Button>
                                    }
                                    {htmlFormError && (<div className="mt-2">{htmlFormError}</div>)}
                                    {htmlFormSuccess && (<div className="mt-2">{htmlFormSuccess}</div>)}
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </section>
            <FooterNew />
            </div> */}
    </>
  );
};

export default SetupPasswordPage;
